export const resolveQrReference = (user) => {
  if (!user) {
    return 'QR-000000';
  }

  const rawReference = typeof user.qrReference === 'string' ? user.qrReference.trim() : '';
  if (rawReference) {
    return rawReference;
  }

  const candidateIdentifiers = [
    typeof user.cardNumber === 'string' ? user.cardNumber.trim() : '',
    typeof user.digitalId === 'string' ? user.digitalId.trim() : '',
    typeof user.membershipNo === 'string' ? user.membershipNo.trim() : '',
  ].filter(Boolean);

  if (candidateIdentifiers.length) {
    const base = candidateIdentifiers[0];
    const sanitized = base.replace(/[^A-Za-z0-9]/g, '');
    if (sanitized) {
      return `QR-${sanitized.slice(-8)}`;
    }
    return `QR-${base.replace(/\s+/g, '')}`;
  }

  const numericId = Number(user.id ?? user.userId);
  if (Number.isFinite(numericId) && numericId > 0) {
    return `QR-${String(numericId).padStart(6, '0')}`;
  }

  return 'QR-000000';
};
